module.exports = __webpack_public_path__ + "img/5403.54ea92bc.png";